import type { ComponentSchema } from '../../../../../schema-types'

/** Pathok contact page: contact cards from the section or Store info. Keys follow lightings-1. */
export const schema: ComponentSchema = {
  type: 'contact',
  label: 'Contact',
  description: 'Phone, WhatsApp, email and address cards. Empty fields use Store info.',
  supportedPages: ['contact'],
  variants: [{ id: 'v1', label: 'Contact cards' }],
  commonFields: [
    { key: 'title', label: 'Title', type: 'string', default: 'Contact us' },
    { key: 'description', label: 'Intro text', type: 'localized-text', default: 'Questions about an order or a product? We are happy to help.' },
    { key: 'phone', label: 'Phone (empty: Store info hotline)', type: 'string' },
    { key: 'email', label: 'Email (empty: Store info email)', type: 'string' },
    { key: 'address', label: 'Address (empty: Store info addresses)', type: 'text' },
    { key: 'hoursText', label: 'Opening hours', type: 'localized-text' },
  ],
}
